import React from 'react';

const Expert = ({ expert }) => {
    const { name, img, expertize } = expert;
    return (
      <div className="col-lg-4 col-sm-6 col-12">
        <img className="w-75 h-5" src={img} alt="" />
        <h3>{name}</h3>
        <h5 className="text-danger">{expertize}</h5>
      </div>
    );
};

export default Expert;